import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import { getIdentityTypeLabel } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { StaffType } from "./staff-types";

const useStaffTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Employee Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Phone",
      accessor: "phone",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Email",
      accessor: "email",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Address",
      accessor: "address",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Date Of Joining",
      accessor: "doj",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Role",
      accessor: "roles",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<StaffType>) => (
        <TextCell value={original.role.name} />
      ),
    },
    {
      Header: "Salary",
      accessor: "salary",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Identity",
      accessor: "identity",
      className: "min-w-[150px]",
      Cell: ({ row }: CellProps<StaffType>) => {
        return (
          <div className="flex flex-col">
            <TextCell
              value={
                getIdentityTypeLabel(Number(row.original.identityDoc)) ?? "-"
              }
              className="!p-0"
            />
            <TextCell value={row.original.identityNumber} className="!p-0" />
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<StaffType>) => {
        return <ActionsCell value={value} onDelete={() => onDelete(value)} />;
      },
    },
  ];
};

export default useStaffTableColumns;
